import React from "react";
import { graphql } from "gatsby";
import { Container } from "react-bootstrap";
import AnchorID from "../../atoms/AnchorID";
import "./simpleQuote.scss";

export const ParagraphSimpleQuote = ({ node }) => {
  const {field_section_id, field_quote_text, field_background_colour, field_attribution, field_organization_name } = node;
  return (
    <div className={`simple-quote ${`bg-clr-${field_background_colour}`}`}>
      <AnchorID id={field_section_id}/>
      <Container className="general-container">
        <div className="simple-quote-inner" data-aos="fade-up">
          <div><i className="icon-quote"/></div>
          <div className="strict-h4" dangerouslySetInnerHTML={{__html: field_quote_text.value}}/>
          <p className="designation">
            {field_attribution ? `- ${field_attribution}` : ''}
            {field_organization_name ? `, ${field_organization_name}` : ''}</p>
        </div>
      </Container>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphSimpleQuote on paragraph__simple_quote {
    field_section_id
    field_attribution
    field_background_colour
    field_quote_text {
      value
    }
    field_organization_name
  }
`;
